module.exports = __webpack_public_path__ + "static/img/login.8fe89a4c.png";